const en_US = {
  title: 'Notification Template Management',
  list: 'List',
  channel: 'Channel',
  contact_key_name: 'Contact Name',
  contact_key: 'Contact Key',
  hide_channel: 'Hide Channel',
  hide_contact: 'Hide Contact',
  hide: {
    0: 'No',
    1: 'Yes',
  },
};
export default en_US;
